import { getFingerprint } from "./fingerprint";

/**
 * Build security headers for API requests. Used by the Axios request interceptor.
 * Currently includes X-Device-Fingerprint only.
 */
export async function buildSecurityHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  try {
    const fp = await getFingerprint();
    if (fp) headers["X-Device-Fingerprint"] = fp;
  } catch {
    // Fingerprint failure must not block requests; BE may still accept without it
  }
  return headers;
}
